<template>
  <div>
    <div>
      <div class="form-group row mt-5 mb-4">
        <label class="col-sm-4">Biztosítás jellege:</label>
        <div class="col-sm-8">
          <span v-if="insuranceType == 1">Egy útra</span>
          <span v-if="insuranceType == 2">Oda-vissza útra</span>
          <span v-if="insuranceType == 3">Több útra</span>
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Honnan hová:</label>
        <div class="col-sm-8">{{ fromCountryName }} -> {{ toCountryName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Feltétel:</label>
        <div class="col-sm-8">
          {{ condition === 'alt' ? 'Általános feltétel' : 'Nemzetközi feltétel' }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Záradék:</label>
        <div class="col-sm-8">{{ clauseText }}</div>
      </div>

      <h1 class="mt-4">Szállítmány adatai</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Árutípus:</label>
        <div class="col-sm-8">{{ shipmentType === 'uj' ? 'Új' : 'Haszált' }} áru</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Pénznem:</label>
        <div class="col-sm-8" style="text-transform: uppercase">{{ currency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Biztosítás összege:</label>
        <div class="col-sm-8">
          {{
            insuranceAmount
              | currency({
                symbol: currencySymbol,
                symbolPosition: currency === 'huf' ? 'back' : 'front',
              })
          }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Áruérték:</label>
        <div class="col-sm-8">
          {{
            shipmentValue
              | currency({
                symbol: currencySymbol,
                symbolPosition: currency === 'huf' ? 'back' : 'front',
              })
          }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Árukategória:</label>
        <div class="col-sm-8">{{ itemTypeName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Áru megnevezése:</label>
        <div class="col-sm-8">{{ shipmentName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Kártérítési alap:</label>
        <div class="col-sm-8">{{ compensationFundText }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Szállítási mód:</label>
        <div class="col-sm-8">{{ shipmentList }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Önrész</label>
        <div class="col-sm-8">{{ deductibleAmountText }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Paritás</label>
        <div class="col-sm-8">{{ parity }}</div>
      </div>

      <h1 class="mt-4">Kockázatviselés időtartama</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Kockázatviselés kezdete:</label>
        <div class="col-sm-8">{{ new Date(insuranceStart).toLocaleDateString('hu-HU') }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Kockázatviselés vége:</label>
        <div class="col-sm-8">
          Az áru rendeltetési helyre történő megérkezése, de legkésőbb
          {{ new Date(insuranceEnd).toLocaleDateString('hu-HU') }} 24:00 órája
        </div>
      </div>

      <h1 class="mt-4">Díjfizetési mód</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Díjfizetés módja:</label>
        <div class="col-sm-8">{{ paymentType === 'online' ? 'Online' : 'Átutalás' }}</div>
      </div>
    </div>

    <h1 class="mt-5">Szerződés adatok</h1>

    <h1>Szerződő adatai</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő neve:</label>
      <div class="col-sm-8">{{ companyName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Adószám</label>
      <div class="col-sm-8">{{ companyVat }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Irányítószám:</label>
      <div class="col-sm-8">{{ companyPostalCode }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Település:</label>
      <div class="col-sm-8">{{ companyCity }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Utca, házszám:</label>
      <div class="col-sm-8">{{ companyAddress }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Email:</label>
      <div class="col-sm-8">{{ companyEmail }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Telefon:</label>
      <div class="col-sm-8">+36 {{ companyPhoneArea }} {{ companyPhone }}</div>
    </div>

    <template v-if="!companyIsTheInsured">
      <h1 class="mt-4">Biztosított adatai</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Biztosított neve:</label>
        <div class="col-sm-8">{{ insuredName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ insuredPostalCode }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Település:</label>
        <div class="col-sm-8">{{ insuredCity }}</div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4">Utca, házszám:</label>
        <div class="col-sm-8">{{ insuredAddress }}</div>
      </div>
    </template>

    <!-- <div class="form-group row mb-2" v-if="merchant_id">
            <label class="col-sm-4" for="merchant_email">Biztosításközvetítő e-mail címe:</label>
            <ValidationProvider rules="email" v-slot="{ errors, classes }" class="col-sm-4">
                <input type="email" class="form-control" id="merchant_email" name="merchant_email" v-model="merchantEmail" :class="classes">
                <small id="merchant_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
        </div> -->

    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <div class="form-check mb-4" v-if="condition === 'alt'">
        <ValidationProvider name="biztositasi_feltetelek" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="nyilatkozatok[]"
            value="biztositasi_feltetelek"
            v-model="electronicCommunation"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Általános Szállítmánybiztosítás biztosítási feltételek elfogadása
            <div
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></div></b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Atlasz Általános
            Szállítmánybiztosítás Biztosítási Feltételeit és Ügyféltájékoztatóját, a Biztosítási
            termékismertetőjét, az Általános Szállítmánybiztosítási Feltételek Kigeszítő és
            Értelmező I. Záradékát, az Általános Kizárások Záradékát és a Kárrendezési Dokumentumok
            Záradékát.
            <iframe
              class="w-100 mt-2"
              style="height: 500px;"
              :src="`https://colonnade.hu/media/atlasz-altalanos-szallitmanybiztositas`"
              frameborder="0"
            ></iframe>
          </div>
        </label>
        <p>
          <a
            href="https://colonnade.hu/media/altalanos-szallitmanybiztositasi-feltetelek-kiegeszito-es-ertelmezo-zaradeka-i"
            target="”_blank”"
            >ÁLTALÁNOS SZÁLLÍTMÁNYBIZTOSÍTÁSI FELTÉTELEK KIEGÉSZÍTŐ ÉS ÉRTELMEZŐ ZÁRADÉKA I. (MJK:
            ÁLTSZÁLLKÉZ 001-2023)</a
          >
        </p>
        <p>
          <a href="https://colonnade.hu/media/altalanos-kizarasok-zaradeka" target="”_blank”"
            >ÁLTALÁNOS KIZÁRÁSOK ZÁRADÉKA (MJK: ÁLTKIZ 001-2023)</a
          >
        </p>
        <a href="https://colonnade.hu/media/karrendezesi-dokumentumok-zaradeka" target="”_blank”"
          >KÁRRENDEZÉSI DOKUMENTUMOK ZÁRADÉKA (MJK: KÁRDOK 001-2023)</a
        >
      </div>
      <div class="form-check mb-4" v-else>
        <ValidationProvider name="biztositasi_feltetelek" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="nyilatkozatok[]"
            value="biztositasi_feltetelek"
            v-model="electronicCommunation"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Nemzetközi Szállítmánybiztosítás biztosítási feltételek elfogadása
            <div
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></div></b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Atlasz Nemzetközi
            Szállítmánybiztosítás Biztosítási Feltételeit és Ügyféltájékoztatóját, a Biztosítási
            termékismertetőjét, a Nemzetközi Szállítmánybiztosítási Feltételek Kiegészítő és
            Értelmező II. Záradékát , az Általános Kizárások Záradékát és a Kárrendezési
            Dokumentumok Záradékát
            <iframe
              class="w-100 mt-2"
              style="height: 500px;"
              :src="`https://colonnade.hu/media/atlasz-nemzetkozi-szallitmanybiztositas`"
              frameborder="0"
            ></iframe>
          </div>
        </label>
        <p>
          <a
            href="https://colonnade.hu/media/nemzetkozi-szallitmanybiztositasi-feltetelek-kiegeszito-es-ertelmezo-zaradeka-ii"
            target="”_blank”"
            >NEMZETKÖZI SZÁLLÍTMÁNYBIZTOSÍTÁSI FELTÉTELEK KIEGÉSZÍTŐ ÉS ÉRTELMEZŐ ZÁRADÉKA II. (MJK:
            NSZKÉZ 001-2023)</a
          >
        </p>
        <p>
          <a href="https://colonnade.hu/media/karrendezesi-dokumentumok-zaradeka" target="”_blank”"
            >DOKUMENTUMOK ZÁRADÉKA (MJK: KÁRDOK 001-2023)</a
          >
        </p>
        <a href="https://colonnade.hu/media/altalanos-kizarasok-zaradeka" target="”_blank”"
          >ÁLTALÁNOS KIZÁRÁSOK ZÁRADÉKA (MJK: ÁLTKIZ 001-2023)</a
        >
      </div>
      <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="hirlevel"
          name="nyilatkozatok[]"
          value="hirlevel"
          v-model="marketingMails"
        />
        <label for="hirlevel" class="form-check-label">
          <b>Szeretnék értesülni az aktuális ajánlatokról, akciókról</b><br />
          Kijelentem, hogy önkéntesen hozzájárulok ahhoz, hogy a Colonnade Insurance S.A.
          Magyarországi Fióktelepe a megadott személyes adataimat (név, telefonszám, e-mail cím)
          közvetlen üzletszerzés céljából kezelje és azokon megkeressen. Hozzájárulásomat bármikor,
          korlátozás és indoklás nélkül, ingyenesen visszavonhatom az info@colonnade.hu címre
          küldött emailben.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="adatvedelmi_nyilatkozat" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="adatvedelmi_nyilatkozat"
            name="nyilatkozatok[]"
            value="adatvedelmi_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatvedelmi_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; Tudomásul veszem, hogy a Colonnade Insurance S.A.
          Magyarországi Fióktelepe (székhely: 1134 Budapest, Váci út 23-27.) adatkezelő által a
          <a href="https://colonnade.nopa.hu" target="_blank">https://colonnade.nopa.hu</a>
          felhasználói adatbázisában tárolt személyes adataim átadásra kerülnek az OTP Mobil Kft.,
          mint adatfeldolgozó részére. Amennyiben más személyek személyes adatait adtam meg (vagy
          fogom megadni) a Biztosítónak, kijelentem, hogy az érintett személyeket tájékoztattam az
          adatvédelmi szabályzat tartalmáról, illetve ezen rendelkezéseknek megfelelően fel vagyok
          hatalmazva az érintett személyek személyes adatainak továbbítására a Biztosító részére. A
          Biztosító adatvédelmi szabályzata közvetlenül
          <a href="https://www.colonnade.hu/media/adatkezelesi-tajekoztato.pdf" target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="tudomasul_veszem" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="tudomasul_veszem"
            name="nyilatkozatok[]"
            value="tudomasul_veszem"
            v-model="acceptTerms"
          />
        </ValidationProvider>
        <label for="tudomasul_veszem" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosításkötéssel kapcsolatos nyilatkozat
            <div
              :class="insuranceBondStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceBondStatementClick"
            ></div
          ></b>
          <ul v-show="insuranceBondStatementOpened">
            <b>Tudomásul veszem, hogy:</b>
            <li>
              jelen ajánlat a Biztosító kockázat elbírálásának alapja;
            </li>
            <li>
              a Biztosítónak az ajánlattételtől számítva 15 nap áll rendelkezésére az ajánlat
              elbírálására;
            </li>
            <li>
              a Biztosító a kockázatelbírálás eredményeként az ajánlatot indoklás nélkül
              visszautasíthatja, ebben az esetben a biztosítási szerződés nem jön létre;
            </li>
            <li>
              ha a biztosítási esemény a kockázatelbírálási idő alatt bekövetkezik, a Biztosító az
              ajánlatot csak abban az esetben utasíthatja vissza, ha az igényelt biztosítási fedezet
              jellege vagy a kockázatviselés körülményei alapján nyilvánvaló, hogy az ajánlat
              elfogadásához a kockázat egyedi elbírálása szükséges;
            </li>
            <li>
              az ajánlattételkor befizetett összeget a Biztosító díjelőlegként kezeli, az ajánlat
              elfogadása esetén pedig díjfizetésnek tekinti, amennyiben a Biztosító az ajánlatot
              elutasítja, a Biztosító a biztosítási díjat a szerződőnek kamatmentesen visszautalja;
            </li>
            <li>
              bármely szóbeli közlés vagy kikötés akkor érvényes, ha azokat a Biztosító írásban
              megerősítette;
            </li>
            <li v-if="merchant_id !== 'colo213' && merchant_id !== null">
              a Biztosító az {{ isDomestic }} termékkel kapcsolatosan nem nyújt tanácsadást, a
              termék értékesítése pedig közvetlenül a biztosító online értékesítési felületén
              keresztül történik,az értékesítési folyamatban biztosításközvetítő működik közre, aki
              a Biztosítótól közvetett díjazás/jutalék jellegű javadalmazásban részesül.
            </li>
            <li v-else>
              a Biztosító az {{ isDomestic }} termékkel kapcsolatosan nem nyújt tanácsadást, a
              termék értékesítése pedig közvetlenül a biztosító online értékesítési felületén
              keresztül történik, az értékesítési folyamatban biztosításközvetítő működik közre.
            </li>
            <li>
              a biztosítási szerződés megkötésére a jelen szerződéskötést megelőzően rendelkezésre
              bocsátott, ezen felületen megadott adatok alapján került sor.
            </li>
          </ul>
        </label>
      </div>
      <!-- <div class="form-check mb-4" v-if="merchant_id !== 'colo213' && merchant_id !== null">
        <ValidationProvider name="biztositaskozvetito" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="nyilatkozatok[]"
            value="biztositaskozvetito"
            v-model="validMerchant"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Amennyiben a biztosítási szerződést független biztosításközvetítő értékesíti, a
            biztosításközvetítő kijelenti, hogy az ügyletre megfelelő alkuszi megbízással
            rendelkezik.</b
          >
        </label>
      </div> -->
      <div class="form-check mb-4">
        <ValidationProvider name="valos_adatok" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="valos_adatok"
            name="nyilatkozatok[]"
            value="valos_adatok"
            v-model="validDatas"
          />
        </ValidationProvider>
        <label for="valos_adatok" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Nyilatkozat a szokásostól eltérő szerződési gyakorlat és a Ptk.-tól való eltérés
            elfogadásáról
            <div
              :class="contractPracticeStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="contractPracticeStatementClick"
            ></div
          ></b>
          <ul class="hyphens" v-show="contractPracticeStatementOpened">
            <b>Kijelentem, hogy:</b
            ><br />
            Tájékoztatást kaptam arra vonatkozóan, hogy az
            {{
              isDomestic
            }}
            feltételeinek alábbi rendelkezései lényegesen eltérnek a Polgári Törvénykönyvről szóló
            2013. évi V. törvény (Ptk.) vonatkozó rendelkezéseitől:
            <li>
              A Ptk. 6:22.§ (1) bekezdésében foglalt 5 éves elévülési időtől eltérően a biztosítási
              szerződésből eredő igények egy év alatt évülnek el).
            </li>
            <li>
              A Ptk. 6:63. § (5) bekezdésétől eltérően nem válik a Biztosítási szerződés tartalmává
              a Felek esetleges korábbi szerződéses/üzleti gyakorlata, szokása, illetve a
              biztosítási üzletágban a hasonló jellegű szerződés alanyai által széles körben ismert
              és rendszeresen alkalmazott szokás.
            </li>
            <li>
              A biztosítási szerződés a 2013.évi V törvény (Ptk) 6:443. § (1) pontjától eltérően a
              Szerződő írásbeli ajánlata és a Biztosító által ennek alapján kibocsátott fedezetet
              igazoló dokumentum /kötvény/ alapján jön létre.
            </li>
            <li>
              A Ptk. 6:461. §- ától eltérően, a fedezetfeltöltés joga az alábbiak szerint illeti meg
              a szerződőt: - Az adott biztosítási időszakra vonatkozó biztosítási összeg az
              ugyanazon biztosítási időszakban bekövetkezett biztosítási esemény miatt kifizetett
              összeggel csökken, kivéve, ha a szerződő fél a díjat megfelelően kiegészíti.
            </li>
            Kijelentem, hogy az
            {{
              isDomestic
            }}
            a szokásos szerződési gyakorlattól eltérő rendelkezéseit elfogadom, azokat magamra nézve
            kötelezőnek ismerem el.
          </ul>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="szankcios_nyilatkozat" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="szankcios_nyilatkozat"
            name="nyilatkozatok[]"
            value="szankcios_nyilatkozat"
            v-model="merchantInformedCustomer"
          />
        </ValidationProvider>
        <label for="szankcios_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Kijelentem, hogy az általam képviselt társaság ismeri és betartja a
            szerződőre/biztosítottra, illetve az általuk folytatott gazdasági tevékenységre irányadó
            kereskedelmi és gazdasági szankciókat, korlátozásokat.</b
          >
        </label>
      </div>
      <div class="form-check mb-4" v-if="merchant_id !== 'colo213' && merchant_id !== null">
        <ValidationProvider name="biztositaskozvetito" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="nyilatkozatok[]"
            value="biztositaskozvetito"
            v-model="sanctionsStatement"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Amennyiben a biztosítási szerződést biztosításközvetítő értékesíti, a
            biztosításközvetítő kijelenti, hogy az ügyletre megfelelő megbízással rendelkezik, a
            biztosító adatairól, a biztosítási szerződés jellemzőiről a biztosításkötést megelőző
            nyilatkozatok tartalmáról tájékoztatta az ügyfelet, aki a tájékoztatást és annak
            tartalmát tudomásul vette és elfogadta.</b
          >
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="ekapcsolat" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="ekapcsolat"
            name="consents[]"
            value="ekapcsolat"
            v-model="ekapcsolatStatement"
          />
        </ValidationProvider>
        <label for="ekapcsolat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;
          <b
            >Elektronikus kapcsolattartás nyilatkozat
            <div
              :class="ekapcsolatOpened ? 'arrow-up' : 'arrow-down'"
              @click="ekapcsolatClick"
            ></div></b
          ><br />
          <div v-show="ekapcsolatOpened">
            Hozzájárulok, hogy a Biztosító a biztosítási szerződéssel kapcsolatos kommunikációt
            elektronikus úton, az általam megadott email címen folytassa. Megértettem, hogy a
            Biztosító fenntartja a jogot, hogy egyes iratokat postai úton küldjön, ha jogszabály
            vagy hatósági előírás ezt megköveteli, vagy ha technikai akadályok merülnek fel.
            Elfogadom, hogy a hibás vagy elavult adatokból eredő késedelmekért a Biztosító nem
            felel.
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="oroszorszag" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="oroszorszag"
            name="consents[]"
            value="oroszorszag"
            v-model="orosz_nyilatkozat"
          />
        </ValidationProvider>
        <label for="oroszorszag" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; Kijelentem, hogy az általam képviselt
          társaság/szerződő nem rendelkezik sem közvetetten, sem közvetlenül orosz, fehérorosz
          tulajdonossal vagy ellenőrző befolyást gyakorló személlyel (Oroszországban,
          Fehéroroszországban bejegyzett cég, vagy ezen országokban állandó lakcímmel rendelkező
          magánszemélyek); és az általam képviselt társaság/szerződő nem rendelkezik Oroszországban
          vagy Fehéroroszországban bejegyzett társasággal, eszközzel, érdekeltséggel vagy állandó
          telephellyel.
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {parse as parseMoney} from 'vue-currency-input';

export default {
  data() {
    return {
      insuranceTermsOpened: true,
      insuranceBondStatementOpened: false,
      contractPracticeStatementOpened: false,
      ekapcsolatOpened: false,
    };
  },
  computed: {
    ...mapFields([
      'countries',
      'itemList',
      'merchant_id',

      'insuranceType',
      'fromCountry',
      'toCountry',
      'condition',
      'clause',

      'shipmentType',
      'currency',
      'insuranceAmount',
      'shipmentValue',
      'shipmentCategory',
      'shipmentName',
      'compensationFund',
      'hasVehicleTransport',
      'hasTrainTransport',
      'hasShipTransport',
      'hasAirTransport',

      'deductibleAmount',
      'parity',

      'insuranceStart',
      'insuranceEnd',

      'paymentType',

      'companyName',
      'companyVat',
      'companyPostalCode',
      'companyCity',
      'companyAddress',
      'companyEmail',
      'companyPhoneArea',
      'companyPhone',

      'companyIsTheInsured',

      'insuredName',
      'insuredPostalCode',
      'insuredCity',
      'insuredAddress',

      'statementSettings.privacyStatement',
      'statementSettings.insuranceTerms',
      'statementSettings.electronicCommunation',
      'statementSettings.marketingMails',
      'statementSettings.acceptTerms',
      'statementSettings.validMerchant',
      'statementSettings.validDatas',
      'statementSettings.merchantInformedCustomer',
      'statementSettings.sanctionsStatement',
      'statementSettings.ekapcsolatStatement',
      'statementSettings.orosz_nyilatkozat',
    ]),
    isDomestic() {
      if (this.fromCountry === 'HU' && this.toCountry === 'HU') {
        return 'Atlasz Általános Szállítmánybiztosítási';
      } else {
        return 'Atlasz Nemzetközi Szállítmánybiztosítási';
      }
    },

    clauseText: {
      get() {
        switch (this.clause) {
          case 'alt_a':
            return 'All Risks záradék';
          case 'alt_b':
            return 'W.A. vagy W.P.A. záradék';
          case 'alt_c':
            return 'F.P.A. záradék';
          case 'nemz_a':
            return 'Institue Cargo Clauses (A) 1/1/82 CL. 252';
          case 'nemz_b':
            return 'Institue Cargo Clauses (B) 1/1/82 CL. 253';
          case 'nemz_c':
            return 'Institue Cargo Clauses (C) 1/1/82 CL. 254';
        }
      },
    },
    compensationFundText: {
      get() {
        switch (this.compensationFund) {
          case 'uj_1':
            return 'Az áru számla szerinti értéke';
          case 'uj_2':
            return 'Az áru számla szerinti értéke + 10% felülbiztosítás';
          case 'uj_3':
            return 'Az áru számla szerinti értéke + fuvardíj + 10% felülbiztosítás';
          case 'hasznalt_1':
            return 'Műszaki avult (valóságos) érték, de max. az aktuális piaci avult érték';
          case 'hasznalt_2':
            return 'Utánpótlási / új érték';
        }
      },
    },
    shipmentList: {
      get() {
        const listOfTransports = [];

        if (this.hasVehicleTransport) listOfTransports.push('Tehergépjármű');
        if (this.hasTrainTransport) listOfTransports.push('Vasút');
        if (this.hasShipTransport) listOfTransports.push('Hajó');
        if (this.hasAirTransport) listOfTransports.push('Repülő');

        return listOfTransports.length === 0 ? '—' : listOfTransports.join(', ');
      },
    },
    // deductibleAmountText: {
    //   get() {
    //     switch (this.deductibleAmount) {
    //       case 'nincs':
    //         return 'Nincs';
    //       case 'osszeghuf':
    //         return '100.000 HUF/kár';
    //       case 'osszeg':
    //         return '300 EUR vagy USD/kár';
    //       case 'szazalek':
    //         return '10%, de min 300 EUR/USD vagy 100.000 HUF/kár';
    //     }
    //   },
    // },
    deductibleAmountText: {
      get() {
        if (this.currency === 'huf') {
          switch (this.deductibleAmount) {
            case 'nincs':
              return 'Nincs';
            case 'osszeg':
              return '100.000 HUF/kár';
            case 'szazalek':
              return '10%, de min 100.000 HUF/kár';
          }
        }
        if (this.currency === 'usd') {
          switch (this.deductibleAmount) {
            case 'nincs':
              return 'Nincs';
            case 'osszeg':
              return '300 USD/kár';
            case 'szazalek':
              return '10%, de min 300 USD/kár';
          }
        }
        if (this.currency === 'eur') {
          switch (this.deductibleAmount) {
            case 'nincs':
              return 'Nincs';
            case 'osszeg':
              return '300 EUR/kár';
            case 'szazalek':
              return '10%, de min 300 EUR/kár';
          }
        }
      },
    },
    fromCountryName: {
      get() {
        return this.countries.find((country) => country.id === this.fromCountry)?.text ?? '—';
      },
    },
    toCountryName: {
      get() {
        return this.countries.find((country) => country.id === this.toCountry)?.text ?? '—';
      },
    },
    itemTypeName: {
      get() {
        return this.itemList.find((item) => item.id == this.shipmentCategory)?.name ?? '—';
      },
    },
    currencySymbol: {
      get() {
        const currencies = {huf: 'Ft', eur: '€', usd: '$'};

        return currencies[this.currency];
      },
    },
  },
  methods: {
    insuranceTermsClick(e) {
      if (e) e.preventDefault();
      this.insuranceTermsOpened = !this.insuranceTermsOpened;
    },
    ekapcsolatClick(e) {
      if (e) e.preventDefault();
      this.ekapcsolatOpened = !this.ekapcsolatOpened;
    },
    insuranceBondStatementClick(e) {
      if (e) e.preventDefault();
      this.insuranceBondStatementOpened = !this.insuranceBondStatementOpened;
    },
    contractPracticeStatementClick(e) {
      if (e) e.preventDefault();
      this.contractPracticeStatementOpened = !this.contractPracticeStatementOpened;
    },
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;

ul.hyphens {
  list-style-type: none;
}

ul.hyphens > li:before {
  content: '–';
  position: absolute;
  margin-left: -1.1em;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}

.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
